import React from 'react';
import { Row, Col, Statistic } from 'antd';
import { DollarOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { PerformanceSummaryProps } from './types';
import { SummaryCard } from './styles';

const PerformanceSummary: React.FC<PerformanceSummaryProps> = ({
  summary,
  borderColor = '#1890ff',
}) => {
  return (
    <SummaryCard borderColor={borderColor}>
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="Total Revenue"
            value={summary?.totalRevenue || 0}
            prefix={<DollarOutlined />}
            valueStyle={{ color: '#52c41a', fontSize: '24px', fontWeight: 700 }}
            formatter={(value) => `$${Number(value).toLocaleString()}`}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="Total Volume"
            value={summary?.totalVolume || 0}
            prefix={<ShoppingCartOutlined />}
            valueStyle={{ color: '#1890ff', fontSize: '24px', fontWeight: 700 }}
            formatter={(value) => Number(value).toLocaleString()}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="Average Revenue"
            value={summary?.averageRevenue || 0}
            prefix={<DollarOutlined />}
            valueStyle={{ fontSize: '18px', fontWeight: 600 }}
            formatter={(value) => `$${Number(value).toFixed(2)}`}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="Average Volume"
            value={summary?.averageVolume || 0}
            prefix={<ShoppingCartOutlined />}
            valueStyle={{ fontSize: '18px', fontWeight: 600 }}
            formatter={(value) => Number(value).toFixed(0)}
          />
        </Col>
      </Row>
    </SummaryCard>
  );
};

export default PerformanceSummary;
